import React, { useRef ,useState} from "react";
import * as C from "../componentsM/index";
import { Link } from "react-router-dom";

// Sections JSON (you'll fill in actual text later)
const sections = [
   {
    id: ".",
    title: "",
    content: "",
  },
    {
    id: "..",
    title: "",
    content: "",
  },
  { id: "preamble", title: "Preamble", content: `It is the will of The International School  (TIS) to establish an order:
Wherein the community shall exercise its powers and authority through the chosen representatives of its people; 
Wherein the principles of democracy, freedom, equality, tolerance and social justice, shall be fully observed; 
Therein shall be guaranteed fundamental rights, including equality of status, of opportunity and before law, social, economic and political justice, and freedom of thought, expression, belief, faith, worship and association, subject to law and public morality; 
Wherein the independence of the judiciary shall be fully secured; 
So that the community of The International School may prosper and attain their rightful and honored place amongst the World and make their full contribution towards international peace and progress and happiness of humanity: 
Now, therefore, we, the citizens (people) of The International School (TIS), the state
Cognizant of our role and responsibility; 
Dedicated to the preservation of democracy against oppression and tyranny; 
Inspired by the resolve to protect our unity and solidarity by creating an egalitarian community through an order; 
Do hereby, through our representatives in TIS Parliament, adopt, enact and give to ourselves, this Constitution.

`},
  { id: "article1", title: "Article 1: Introduction", content: `
    The Constituencies
The constituencies of The International School shall comprise of those registered and full-time students attending any years of study or grades or classes as below:
(a) 	Preschool (Toddlers, playgroup, Prep1, Prep2) 
(b) 	Primary (Grade1, Grade 2, Grade 3, Grade 4, Grade 5) 
(c) 	Middle Section (MYP1, MYP2, MYP3, MYP4, MYP 5)
(d) 	High Section (DP1, DP2)
and special groups as follows 
(e)	Creativity, Action and Service (CAS) Student Leaders 
(f)	Continent Leaders
(g)	Teachers
(h)	Parents

Parliament may by law admit into the list of constituencies or areas on such terms and conditions as it thinks fit.

Creativity, Action and Service (CAS) Leaders 
Volunteers approved by President to become leaders of their respective CAS programs.

Continent Leaders
Students selected by the President to become the leaders of the respective continents which equally divide the student body of school for the purpose of inter-school events.
  
State
"The State" means Parliament, and such local or other authorities in The International School as are empowered to impose any law.

Elimination of exploitation
The state will ensure the elimination of all forms of exploitation and the gradual fulfillment of the fundamental principle of the constitution, from each according to his ability to each according to his work. 
 
Right of individuals to be dealt with in accordance with law
(1)	To enjoy the protection of law and to be treated in accordance with law is the inalienable right of every citizen, wherever he may be, and of every other person for the time being within The International School. 
(2)	In particular :- 
(a)	no action detrimental to the life, liberty, body, reputation or property of any person shall be taken except in accordance with law; 
(b)	no person shall be prevented from or be hindered in doing that which is not prohibited by law; and 
(c)	no person shall be compelled to do that which the law does not require him to do. 

Loyalty to State and obedience to Constitution and law.
(1)	Loyalty to the State is the basic duty of every citizen.
(2)	Obedience to the Constitution and law is the [4] [inviolable] obligation of every citizen wherever he may be and of every other person for the time being within The International School. 



High treason
(1)	Any person who abrogates or attempts or conspires to abrogate, subverts or attempts or conspires to subvert the Constitution by use of force or show of force or by other unconstitutional means shall be guilty of high treason. 
(2)	Any person aiding or abetting the acts mentioned in clause (1) shall likewise be guilty of high treason. 
(3)	Parliament shall by law provide for the punishment of persons found guilty of high treason. 
` },
  { id: "article2", title: "Article 2: Fundamental Rights and Principles of Policy", content: `
    Fundamental Rights
2.1.1	Laws inconsistent with or in derogation of fundamental rights to be void.
(1)	Any law, or any custom or usage having the force of law, in so far as it is inconsistent with the rights conferred by this Chapter, shall, to the extent of such inconsistency, be void. 
(2)	The State shall not make any law which takes away or abridges the rights so conferred and any law made in contravention of this clause shall, to the extent of such contravention, be void. 
(3)	The provisions of this Article shall not apply to any law relating to members of forces as are charged with the maintenance of public order, for the purpose of ensuring the proper discharge of their duties or the maintenance of discipline among them; and no such law nor any provision thereof shall be void on the ground that such law or provision is inconsistent with, or repugnant to, any provision of this Chapter. 
(4)	The rights conferred by this Chapter shall not be suspended except as expressly provided by the Constitution. 

2.1.2	Security of person.
No person shall be deprived of life or liberties save in accordance with law. 
 
2.1.3	Safeguards as to detention. 
(1)	No person who is detained by any authority empowered to do so by the state without being informed, as soon as may be, of the grounds for detention, nor shall he be denied the right to consult and be defended by a legal practitioner of his choice.
(2)	Every person who is arrested and detained by an authority empowered to do so by state in custody shall be produced before a judge or any approved The International School staff by the President within a period of twenty-four hours, 

2.1.4	Slavery, forced labour, etc. prohibited.
 	(1)	Slavery is non-existent and forbidden and no law shall permit or facilitate its 			introduction in any form.
(2)	All forms of forced labour and traffic in human beings are prohibited. 
(3)	Nothing in this Article shall be deemed to affect compulsory service:- 
(a)	by any person undergoing punishment for an offence against any law; or
(b)	required by any law for public purpose provided that no compulsory service shall be of a cruel nature or incompatible with human dignity. 
	
	

2.1.5	Protection against retrospective punishment.
	No law shall authorize the punishment of a person:- 
(a)	for an act or omission that was not punishable by law at the time of the act or omission; or
(b)	for an offence by a penalty greater than, or of a kind different from, the penalty prescribed by law for that offence at the time the offence was committed. 

2.1.6	Protection against double punishment and self incrimination.
No person:- 
(a)	shall be prosecuted or punished for the same offence more than once; or 
(b)	shall, when accused of an offence, be compelled to be a witness against himself. 

2.1.7	Inviolability of dignity of man
(1)	The dignity of man and, subject to law, shall be inviolable.
(2)	No person shall be subjected to torture for the purpose of extracting evidence.

2.1.8	Freedom of movement 
All shall have the right to remain in, and, subject to any reasonable restriction imposed by law in the public interest, enter and move freely
 
2.1.9	Freedom of assembly.
All shall have the right to assemble peacefully and without arms, subject to any reasonable restrictions imposed by law in the interest of public order.
 
2.1.10	Freedom of association.
(1)	Every citizen shall have the right to form associations or unions, subject to any reasonable restrictions imposed by law in the interest of public order or morality
(2)	All, not being in the service of The International School, shall have the right to form or be a member of a political party, subject to any reasonable restrictions imposed by law in the interest of the sovereignty or integrity of The International School or public order [Provided that no political party shall promote sectarian, ethnic, regional hatred or animosity, or be titled or constituted as a militant group or section.]
(3)	Every political party shall account for the source of its funds in accordance with law. Every political party shall, subject to law, hold intra-party elections to elect its office-bearers and party leaders.

2.1.11.	Freedom of trade, business or profession.
Subject to such qualifications as may be prescribed by law, all shall have the right to enter upon any lawful profession or occupation, and to conduct any lawful trade or business: Provided that nothing in this Article shall prevent:- 
(a)	the regulation of any trade or profession by a licensing system; or
(b)	the regulation of trade, commerce or industry in the interest of free competition therein;




2.1.12	Freedom of speech,
Every citizen shall have the right to freedom of speech and expression, and there shall be freedom of the press, subject to any reasonable restrictions imposed by law in the interest of the integrity, security or defense of The International School or any part thereof, friendly relations with foreign States, public order, decency or morality, or in relation to contempt of court, or incitement to an offence.
 
2.1.13	Freedom to profess religion 
Subject to law, public order and morality every citizen shall have the right to profess, practice and propagate his religion; 

2.1.14	Protection of property rights.
(1)	No person shall be compulsorily deprived of his property save in accordance with law.
(2)	No property shall be compulsorily acquired or taken possession of save for a public purpose, and save by the authority of law which provides for compensation therefore and either fixes the amount of compensation or specifies the principles on and the manner in which compensation is to be determined and given.
(3)	Nothing in this Article shall affect the validity of :- 
(a)	any law permitting the compulsory acquisition or taking possession of any property for preventing danger to life, property or public health; or
(b)	any law permitting the taking over of any property which has been acquired by, or come into the possession of, any person by any unfair means, or in any manner, contrary to law; or
(c)	any law providing for the taking over of the management of any property by the State for a limited period, either in the public interest or in order to secure the proper management of the property, or for the benefit of its owner; or 
(4)	The adequacy or otherwise of any compensation provided for by any such law as is referred to in this Article, or determined in pursuance thereof, shall not be called in question in any court. 

2.1.15.	Equality of citizens.
(1)	All citizens are equal before law and are entitled to equal protection of law.
(2)	There shall be no discrimination on the basis of sex alone
(3)	Nothing in this Article shall prevent the State from making any special provision for the protection of women and children. 

2.1.16.	Non-discrimination in respect of access to public places.
(1)	In respect of access to places, there shall be no discrimination against any citizen on the ground only of race, religion, caste, sex, residence or place of birth.
(2)	Nothing in clause (1) shall prevent the State from making any special provision for women and children.







 	2.1.17.	Safeguard against discrimination in services.
No citizen otherwise qualified for appointment in the service of the state shall be
discriminated against in respect of any such appointment on the ground only of
race, religion, caste, sex, residence or place of birth. 

2.1.18.	Preservation of language, script and culture.
All having a distinct language, script or culture shall have the right to preserve and promote the same and subject to law, 
Principles of Policy
(1) 	The Principles set out in this Chapter shall be known as the Principles of Policy, and it is the responsibility of each organ and authority of the State, and of each person performing functions on behalf of an organ or authority of the State, to act in accordance with those Principles in so far as they relate to the functions of the organ or authority. 
(2) 	In so far as the observance of any particular Principle of Policy may be dependent upon resources being available for the purpose, the Principle shall be regarded as being subject to the availability of resources. 
(3) 	In respect of each year, the President in relation to the affairs of The International School shall cause to be prepared and laid before Parliament a report on the observance and implementation of the Principles of Policy, and provision shall be made in the rules of procedure of Parliament for discussion on such report. 

2.2.1	 Responsibility with respect to Principles of Policy. 
(1) 	The responsibility of deciding whether any action of an organ or authority of the State, or of a person performing functions on behalf of an organ or authority of the State, is in accordance with the Principles of Policy is that of the organ or authority of the State, or of the person, concerned. 
(2) 	The validity of an action or of a law shall not be called in question on the ground that it is not in accordance with the Principles of Policy, and no action shall lie against the State or any organ or authority of the State or any person on such ground. 
  
2.2.2	Parochial and other similar prejudices to be discouraged. 
The State shall discourage parochial, racial, tribal, sectarian and provincial prejudices among the citizens. 

2.2.3	Full participation of women in national life
Steps shall be taken to ensure full participation of women in all spheres of national life.
 
2.2.4	Protection of minorities. 
The State shall safeguard the legitimate rights and interests of minorities.



2.2.5	Promotion of social justice and eradication of social evils 
The State shall: 
(a) ensure inexpensive and expeditious justice; 
(b) make provision for securing just and humane conditions, 
(c) prevent graffiti, gambling and taking of injurious drugs, printing, publication, circulation and display of obscene literature and advertisements; 
(d) prevent the consumption of illegal contraband 

2.2.6.	 Promotion of social and economic well-being of the people. 
The State shall : 
(a) 	secure the well-being of the people, irrespective of sex, caste, creed or race, by raising their standard, by preventing the concentration of means and distribution in the hands of a few to the detriment of general interest and by ensuring equitable adjustment of rights 
(b) 	provide for all, within the available resources, facilities for study with reasonable rest and leisure; 

2.2.7	Promoting international peace. 
The State shall endeavour to preserve and strengthen fraternal relations among other communities to promote international peace and security, foster goodwill and friendly relations among all and encourage the settlement of international disputes by peaceful means. 

` },
  { id: "article3", title: "Article 3: The TIS Community", content: `
    The President
3.1.1	The President
(1) 	There shall be a President who shall be the Head of State and shall represent the unity of the community. 
(2)	The President of Parliament will always be the Head of school or a representative selected by the Head of the School. The representative will not have executive powers of the President but only act as a reporting figure
(3)	The President is the final authority and all decisions of Parliament have to be approved by the President.

3.1.2	 Oath of President 
Before entering upon office, the President shall make before the Chief Justice of The International School oath in the form set out in the Third Schedule. 

3.1.3	Conditions of President's office. 
The President shall not be a candidate for election as a member 

3.1.4	 Term of office of President. 
(1) 	Subject to the Constitution, the President shall hold office for a term of one year from the day he enters upon his office: 
Provided that the President shall, notwithstanding the expiration of his term, continue to hold office until his successor enters upon his office. 




(2)	Subject to the Constitution, a person holding office as President shall be eligible for re-election to that office, 
(3) 	The President may, by writing under his hand addressed to the Speaker of the National Assembly, resign his office. 

3.1.5	 President's power to grant pardon
The President shall have power to grant pardon, reprieve and respite, and to remit, suspend or commute any sentence passed by any court, tribunal, individual or other authority. 

 3.1.6	Duties of Prime Minister in relation to President. 
It shall be the duty of the Prime Minister: 
(a)	to communicate to the President all decisions of the Cabinet relating to the administration of the affairs of The International School and proposals for legislation; 
(b)	to furnish such information relating to the administration of the affairs of
The International School and proposals for legislation as the President
may call for; and 
(c)	 If the President so requires, to submit for the consideration of the Cabinet any matter on which a decision has been taken by the Prime Minister or a Minister but which has not been considered by the Cabinet.

3.1.7	Speaker to act as, or perform functions of, President. 
(1) 	If the office of President becomes vacant by reason of death, resignation, expiration or removal of the President, the Speaker of the National Assembly shall act as President 
(2) 	When the President, by reason of absence or any other cause, is unable to perform his functions, the Speaker of the National Assembly shall perform the functions of President until the President returns or, as the case may be, resumes his functions.

3.2	Parliament
There shall be a Parliament of The International School consisting of 
the President and 
the Student National Assembly (SNA) and 
TWO elected representatives of the CAS leaders and 
all of the continent leaders
TWO elected teachers of The International School
TWO elected parents of the Parent Teacher Association
 
3.2.1	Student National Assembly (SNA)
A representative body of the student’s whose responsibilities are to
Voice the needs and demands of the student body. For this, the SNA should Contemplate whether the demands are practicable by way of a general debate amongst all members
Present the demands to the President, demonstrating and establishing their feasibility and applicability.



Manage the day-to-day affairs of the school; this includes, but is not limited to Keeping a check on the students’ cleanliness and tidiness
Maintaining discipline during school
Providing academic assistance and counseling to the students
Support the faculty in organizing events and activities at, or for, the school.
Encourage involvement of parents in all activities relating to the school.

For the purpose of election to the National Assembly: the constituencies for the general seats shall be TWO member territorial constituencies and the members to fill such seats shall be elected by direct and free vote in accordance with law; the seats in the National Assembly are reserved as under- 

Constituency/Gender | MALE | FEMALE
MYP 1               | 1    | 1
MYP 2               | 1    | 1
MYP 3               | 1    | 1
MYP 4               | 1    | 1
MYP 5               | 1    | 1
DP 1                | 1    | 1
DP 2                | 1    | 1
# of Seats          | 7    | 7
Total Seats         | 14   |

Subject to the following:
a) 	In the event one male and one male female are amongst the two highest vote getters than both are duly elected members of National assembly
b)	In the event the two highest vote getters are of the same sex then the first candidate of the opposite sex gets to be elected instead of the second highest vote getter if the difference between the percentage of secured votes to total votes in the constituency of the second highest candidate and the opposite sex candidate under consideration is less than or equal to twenty percent.
c)	In the event of any tie there will be a re-election to decide which of the tied candidates becomes elected member of the assembly

3.2.2 	Eligibility to vote 
A person shall be entitled to vote if: 
(a) 	he/she is a full time registered member of The International School; 
(b) 	he/she is not less than [ten] years of age; 
(c)	his/her name appears on the electoral roll; and 
(d) 	he/she is not declared by a competent court to be of unsound mind 

3.2.3	Duration of National Assembly
The National Assembly shall, unless sooner dissolved, continue for a term of one year from the first official day of the academic calendar of The International School and shall stand dissolved on the last official day of the academic calendar. 


3.2.4	Speaker and Deputy Speaker of National Assembly. 
(1) 	After a general election, the National Assembly shall, at its first meeting and to the exclusion of any other business, elect from amongst its members a Speaker and a Deputy Speaker and, so often as the office of Speaker or Deputy Speaker becomes vacant, the Assembly shall elect another member as Speaker or, as the case may be, Deputy Speaker.
 (2) 	Before entering upon office, a member elected as Speaker or Deputy Speaker
shall make before the National Assembly oath in the form set out in the Third Schedule. 
(3) 	When the office of Speaker is vacant, or the Speaker is absent or is unable to perform his functions due to any cause, the Deputy Speaker shall act as Speaker, and if, at that time, the Deputy Speaker is also absent or is unable to act as Speaker due to any cause, such member as may be determined by the rules of procedure of the Assembly shall preside at the meeting of the Assembly. 
(4)	The Speaker or the Deputy Speaker shall not preside at a meeting of the Assembly when a resolution for his/her removal from office is being considered. 
(5) 	The Speaker may, by writing under his hand addressed to the President, resign his office. 
(6) 	The Deputy Speaker may, by writing under his hand addressed to the Speaker, resign his office. 
(7) 	The office of Speaker or Deputy Speaker shall become vacant if:
(a) he/she resigns his office; 
(b) he/she ceases to be a member of the Assembly; 
(c) he/she is removed from office by a resolution of the Assembly, of which not less than seven days' notice has been given and which is passed by the votes of the majority of the total membership of the Assembly. 
(8) 	When the National Assembly is dissolved the Speaker shall continue in his office till the person elected to fill the office by the next Assembly enters upon his office. 

3.2.5 	Summoning and prorogation of Parliament (Majlis-e-Shoora). 
(1)	The President may, from time to time, summon either the Student National Assembly or Parliament in joint sitting to meet at such time and place as he/she thinks fit and may also prorogue the same. 
(2) 	There shall be at least two sessions of the National Assembly every year, and not more than sixty days shall intervene between the last sitting of the Assembly in one session and the date appointed for its first sitting in the next session
 (3) 	On a requisition signed by not less than one-fourth of the total membership of the National Assembly, the Speaker shall summon the National Assembly to meet, at such time and place as he thinks fit, within fourteen days of the receipt of the requisition; and when the Speaker has summoned the Assembly only he may prorogue it. 

3.2.6 	Voting in Assembly and quorum. 
(1) 	Subject to the Constitution, all decisions voting in the Parliament or SNA shall be taken by majority Assembly of the members present and voting, 
(2) 	If at any time during a sitting of the Parliament or SNA the attention of the person presiding is drawn to the fact that less than one-fourth of the total membership of 
the Assembly is present, he shall either adjourn the Assembly or suspend the meeting until at least one-fourth of such membership is present. 



3.2.7	Address by President. 
(a)	The President may address either SNA or Parliament assembled together and may for that purpose require the attendance of the members. 
(b)	The President may send messages to either SNA or Parliament whether with respect to a Bill then pending in Parliament or otherwise, and a House to which any message is so sent shall with all convenient dispatch consider any matter required by the message to be taken into consideration.
(c)	At the commencement of the first session after each general election to the National Assembly and at the commencement of the first session of each year the President shall address the Parliament of the causes of its summons
(d) 	Provision shall be made in the rules for regulating the procedure of a House and the conduct of its business for the allotment of time for discussion of the matters referred to in the address of the President

3.2.8 Right to speak in Parliament
The Prime Minister, a Federal Minister, a Minister of State and the Attorney General shall have the right to speak and otherwise take part in the proceedings of either House, or a joint sitting or any committee thereof, of which he may be named a member, but shall not by virtue of this Article be entitled to vote. 

3.2.9 Dissolution of the National Assembly. 
(a)	The President shall dissolve the National Assembly if so advised by the Prime Minister; and the National Assembly shall, unless sooner dissolved, stand dissolved at the expiration of forty-eight hours after the Prime Minister has so advised. 
 (b) 	the President may also dissolve the National Assembly in his/her discretion 

3.2.10	CAS Leader
The community of CAS leaders will elect from themselves TWO representatives for the two reserved seats in Parliament and such members shall not be subject to dissolution but the term of its members, who shall retire as follows, shall be one academic year. 

3.2.11 Continent Leaders
 All continent leaders will have a reserved seat in Parliament and such members shall not be subject to dissolution but the term of its members, who shall retire as follows, shall be one academic year. 

3.2.12	Teachers
The teachers will elect from themselves TWO representatives for the two reserved seats in Parliament and such members shall not be subject to dissolution but the term of its members, who shall retire as follows, shall be one academic year.

Parents
The Parent Teachers Association will elect from themselves TWO parent representatives for the two reserved seats in Parliament and such members shall not be subject to dissolution but the term of its members, who shall retire as follows, shall be one academic year.



 3.2.12 Qualifications for membership of Parliament 
A person shall not be qualified to be elected or chosen as a member of Parliament unless 
(a)	he/she is a full time registered student of The International School; or a parent of a full time registered student of The International School; or an active teacher of The International School
 (b)	he/she is, in the case of the National Assembly, not less than ten years of age and is enrolled as a voter in any electoral roll 
(d) 	he/she is of good character and is not commonly known as one who violates rules and regulations
 (f) 	he/she is sagacious, righteous and non-profligate and honest and ameen; 
(g) 	he/she has not been given any suspensions or more than two detentions in the year of election 
(h) 	he/she has not, worked against the integrity of The International School or opposed the Ideology of The International School
(i) 	he/she possesses such other qualifications as may be prescribed by Act of Parliament

3.2.13 Disqualifications for membership of Parliament
A person shall be disqualified from being elected or chosen as, and from being, a member of the Parliament, if:- 
(a) 	he/she is of unsound mind and has been so declared by a competent court; or 
(b) 	he/she ceases to be a full time registered student of The International School or parent of at least one full time registered student of The International School; or an active teacher of The International School
(c) 	he/she holds an office of profit in the service of The International School other than an office declared by law not to disqualify its holder; 
(d) 	he/she is propagating any opinion, or acting in any manner, prejudicial to the Ideology of The International School, or morality, or the maintenance of public order, or the integrity or independence of the judiciary of The International School, or which defames or brings into ridicule The International School
(e)	he/she has been awarded a suspension or has exceeded TWO detention in one year of office 
(f) 	he/she has been dismissed from his or her responsibility
(g) 	he/she has been removed the service or office on the grounds of misconduct or moral turpitude;
(h)	he/she is found guilty of a corrupt or illegal practice under any law for the time being in force,  


3.2.14	Vacation of seats. 
(a)	A Member of Parliament may, by writing under his hand addressed to the Speaker or, as the case may be, resigns his seat, and thereupon his seat shall become vacant. 
(b)	A House may declare the seat of a member vacant if, without leave of the House, he remains absent for forty consecutive days of its sittings. 



3.2.15 	Oath of members. 
A person elected to a House shall not sit or vote until he has made before the House oath in the form set out in the Third Schedule. 

3.2.16 	Privileges of members. 
(a) 	Subject to the Constitution and to the rules of procedure of Parliament there shall be freedom of speech in Parliament and no member shall be liable to any proceedings in any court in respect of anything said or any vote given by him in Parliament, and no person shall be so liable in respect of the publication by or under the authority of Parliament of any report, paper, votes or proceedings. 
(b) 	Provision may be made by law for the punishment, by a House, of persons who refuse to give evidence or produce documents before a committee of the House when duly required by the chairman of the committee so to do: 
Provided that any such law- 
(a) may empower a court to punish a person who refuses to give evidence or produce documents; and 
(b) shall have effect subject to such Order for safeguarding confidential matters from disclosure as may be made by the President. 

3.3 	Government
3.3.1	Exercise of executive authority. 
(1) 	The executive authority shall vest in the President and shall be exercised by him, either directly or through officers subordinate to him, in accordance with the Constitution. 
(2)	 Nothing contained in clause (1) shall :- 
(a) 	be deemed to transfer to the President any functions conferred by any existing law on the Government or other authority; or 
(b) 	prevent Parliament from conferring by law functions on authorities other than the President

3.3.2	The Cabinet. 
(1) 	There shall be a Cabinet of Ministers, with the Prime Minister at its head, to aid and advise the President in the exercise of his functions. The Prime Minister, as representative of the President, will act as the head of the SNA. The PM is a member and head of the Cabinet. The responsibilities of the PM include 
Overseeing smooth running of the SNA meetings
Resolving conflicts with the help of the Judicial Council
Ensuring that the members of the SNA are carrying out all their responsibilities concerning, Events organized at, or for, the school
Allocating appropriate number of CRs to work under each member of cabinet  
Presenting the minutes and the results/outcomes of each SNA session and meeting to the President
Act as an intermediary between the SNA and the President  
(2) 	The President, in consultation with the faculty, will forward 3 prospective names of students in good academic,  moral standing aged more than 15 years, who, in his/her opinion, is most likely to command the confidence of the majority of the members of the house to be considered for election by TIS Parliament for the role of Prime Minister, 




(3) 	The person appointed under clause (2) or as the case may be, shall, before entering upon the office, make before the President oath in the form set out in the Third Schedule and shall within a period of sixty days thereof obtain a vote of confidence from the SNA. 
(4) 	The Cabinet, together with the Ministers of State, shall be collectively responsible to the SNA. 
(5) 	The Prime Minister shall hold office during the pleasure of the President, but the President shall not exercise his powers under this clause unless he is satisfied that the Prime Minister does not command the confidence of the majority of the members of Parliament, in which case he shall summon the Parliament and require the Prime Minister to obtain a vote of confidence from the Parliament
(6) 	The Prime Minister may, by writing under his hand addressed to the President, resign his office.
(7) 	A Minister who is not a member of the SNA shall cease to be a Minister and shall not before the dissolution of that SNA be again appointed a Minister unless he is elected a member of SNA:
(8) 	Nothing contained in this Article shall be construed as disqualifying the Prime Minister or any other Minister or a Minister of State for continuing in office during any period during which the SNA stands dissolved, or as preventing the appointment of any person as Prime Minister or other Minister or as Minister of State during any such period.

3.3.3.	 Federal Ministers and Ministers of State. 
(1) 	the President in consultation with faculty shall appoint Federal Ministers and Ministers of State from amongst the members of Parliament on the advice of the Prime Minister: 
(2) 	Before entering upon office, a Federal Minister or Minister of State shall make before the President oath in the form set out in the Third Schedule. 
(3) 	A Federal Minister or Minister of State may, by writing under his hand addressed to the President, resign his office or may be removed from office by the President on the advice of the Prime Minister.

3.3.4	Advisers. 
The President may, on the advice of the Prime Minister, appoint not more than five
Advisers, on such terms and conditions as he may determine. 

 	3.3.5	 Prime Minister continuing in office. 
The President may ask the Prime Minister to continue to hold office until his successor enters upon the office of Prime Minister.

3.3.6	Vote of no-confidence against Prime Minister. 
(1) 	A resolution for a vote of no-confidence moved by not less than twenty per centum of the total membership of the SNA may be passed against the Prime Minister by the National Assembly. 
(2) 	A resolution referred to in clause (1) shall not be voted upon before the expiration of three days, or later than seven days, from the day on which such resolution is moved in the National Assembly. 





(3) 	A resolution referred to in clause (1) shall not be moved in the SNA while the SNA is considering demands for grants. 
(4) 	If the resolution referred to in clause (1) is passed by a majority of the total membership of the SNA, the Prime Minister shall cease to hold office

3.3.7	 Extent of executive authority of Federation. 
Subject to the Constitution, the executive authority of the Federation shall extend to the matters with respect to which Parliament has power to make laws, including exercise of rights, authority and jurisdiction in and in relation to areas outside The International School: 
Provided that the said authority shall not, save as expressly provided in the Constitution or in any law made by Parliament,

3.3.8	Conferring of functions on subordinate authorities. 
On the recommendation of the Federal Government, Parliament may by law confer functions upon officers or authorities subordinate to the Federal Government. 

3.3.9	Conduct of business of Federal Government. 
(1) 	All executive actions of the Federal Government shall be expressed to be taken in the name of the President. 
(2) 	The President shall by rules specify the manner in which orders and other instruments made and executed in his name shall be authenticated, and the validity of any order or instrument so authenticated shall not be questioned in any court on the ground that it was not made or executed by the President. 
(3) 	The President shall also make rules for the allocation and transaction of the business of the Federal Government.

3.3.10	Attorney-General for The International School. 
(1)	 The President shall appoint a person, being a person qualified to be appointed a Judge of the Supreme Court, to be the Attorney-General for The International School. 
(2) 	The Attorney-General shall hold office during the pleasure of the President. 
(3) 	It shall be the duty of the Attorney-General to give advice to the Federal Government upon such legal matters, and to perform such other duties of a legal character as may be referred or assigned to him by the Federal Government, and in the performance of his duties he shall have the right of audience in all courts and tribunals in The International School. 
(4) 	The Attorney-General may, by writing under his hand addressed to the President, resign his office. 

    
    ` },
  { id: "article4", title: "Article 4: Parliamentary Procedures", content: `
    General
4.1.1	 Rules of Procedure 
(1) 	Subject to the Constitution, a House may make rules for regulating its procedure and the conduct of its business, and shall have power to act notwithstanding any vacancy in the membership thereof, and any proceedings in the House shall not 




be invalid on the ground that some persons who were not entitled to do so sat, voted or otherwise took part in the proceedings. 

(2)	Until rules are made under clause (1), the procedure and conduct of business in a House shall be regulated by the rules of procedure made by the President. 

4.1.2	Restriction on discussion in Parliament
No discussion shall take place in Parliament with respect to the conduct of any President or Judge of the Supreme Court or in the discharge of his duties. 

4.1.3 	Courts not to inquire into proceedings of Parliament. 
(1) 	The validity of any proceedings in Parliament shall not be called in question on the ground of any irregularity of procedure. 
(2) 	No officer or Member of Parliament in whom powers are vested by or under the Constitution for regulating procedure or the conduct of business, or for maintaining order in Parliament, shall be subject to the jurisdiction of any court in
respect of the exercise by him of those powers.

4.2	Legislative
4.2.1 	Introduction and passing of Bills. 
(1) 	A Bill with respect to any matter in the Federal Legislative List or in the Concurrent Legislative List may originate and shall, if it is passed by Parliament  without amendment, shall he presented to the President for assent. 

(2) 	If a Bill transmitted under clause (1) is rejected or is not passed or is passed with amendment, the Bill, at the request of the parliament shall be [referred to a Mediation Committee for consideration and resolution thereon]. 

(3) 	Where a Bill is referred to the Mediation Committee under clause (2), the Mediation Committee shall, within 14 days, formulate an agreed Bill which is likely to be passed Parliament and President, and place the agreed Bill before parliament and if the Bill passes, it shall be presented to the President for assent. 

4.2.2	Mediation Committee 
(1)		Parliament shall, within fifteen days from the date of referral of the Bill for consideration and resolution by the Mediation Committee nominate three members each as members of a Mediation Committee.
(2)		Parliament nominates a member of the Mediation Committee as Chairman of the Committee and a member as the Vice-Chairman thereof.
(3)		All decisions of the Mediation Committee shall be made by a majority of the total number of members in the Committee.
(4)		The President shall in consultation with the Speaker of the National Assembly make rules for conduct of business of the Mediation Committee.







4.2.3	Procedure with respect to Money Bill. 
(1)	A Bill or amendment shall be deemed to be a Money Bill if it contains provisions dealing with all or any of the following matters, namely:- 
(a) 	the imposition, abolition, remission, alteration or regulation of any tax; 
(b) 	the borrowing of money, or the giving of any guarantee, by government, or the amendment of the law relating to the financial obligations of that Government; 
(c) 	the payment of moneys into, or the issue of moneys 
(d)	the receipt and custody of moneys 
(e) 	the audit of the accounts 
(f) 	any matter incidental to any of the matters specified in the preceding paragraphs. 
(2)	If any question arises whether a Bill is a Money Bill or not, the decision of the Speaker of the National Assembly thereon shall be final.  Every Money Bill presented to the President for assent shall bear a certificate under the hand of 
the Speaker of the National Assembly that it is a Money Bill, and such certificate shall be conclusive for all purposes and shall not be called in question. 

4.2.4 	Federal Government's consent required for financial measures. 
A Money Bill or a Bill or amendment which if enacted and brought into operation would involve expenditure or withdrawal from the Treasury with the consent of the President

4.2.5 President's assent to Bills. 
(1) 	When a Bill is presented to the President for assent, the President shall, within [fourteen] days,-
(a) 	assent to the Bill; or 
(b) 	in the case of a Bill, return the Bill to the Parliament with a message requesting that the Bill, or any specified provision thereof, be reconsidered and that any amendment specified in the message be considered. 
(2) 	When the President has returned a Bill to Parliament, it shall be reconsidered by the Parliament, if it is again passed, with amendment, by the Parliament it shall be deemed for the purposes of the Constitution to have been passed 
(3) 	When the President has assented to a Bill, it shall become law and be called an Act of Parliament

4.2.6  Bill not to lapse on prorogation 
(1)	A Bill pending shall not lapse by reason of the prorogation of Parliament
(2) 	A Bill pending which has not been passed shall not lapse on the dissolution of Parliament. 

4.2.7	Tax to be levied by law only. 
No tax shall be levied except by or under the authority of Act of Parliament.







4.3 Financial Procedures
4.3.1 Treasury 
All revenues received by Government shall form part of a consolidated fund, to be
known as the Treasury. 

4.3.2 	Custody of Treasury 
The custody of the Treasury, the payment or moneys into that Fund, the withdrawal of moneys there from shall be regulated by Act of Parliament or, until provision in that behalf is so made, by rules made by the President. 

4.3.3	 Annual Budget Statement. 
The Government shall, in respect of every financial year, cause to be laid before
Parliament a statement of the estimated receipts and expenditure of the Government for
that year, referred to as the Annual Budget Statement. 

4.3.4	Expenditure charged upon Treasury Fund. 
The following expenditure shall be expenditure charged upon the Treasury Fund:- 
(a)	the administrative expenses,
(b) 	all debt charges for which the Government is liable, 
(c) 	any other sums declared by the Constitution or by Act of Parliament to be so charged. 

4.3.5	Procedure relating to Annual Budget Statement. 
(1) 	the Annual Budget Statement as relates to expenditure charged upon the Treasury Fund may be discussed in, but shall not be submitted to the vote of, Parliament
(2)	So much of the Annual Budget Statement as relates to other expenditure shall be submitted to Parliament in the form of demands for grants, and parliament shall have power to assent to, or to refuse to assent to, any demand, or to assent to any demand subject to a reduction of the amount specified therein; 
(3)	No demand for a grant shall be made except on the recommendation of the Federal Government. 

4.3.6 	Authentication of schedule of authorized expenditure.
(1)	The Prime Minister shall authenticate by his signature a schedule specifying- 
(a) 	the grants made or deemed to have been made by Parliament, and 
(b) 	the several sums required to meet the expenditure charged upon the TreasuryFund but not exceeding, in the case of any sum, the sum shown in the statement previously laid before Parliament
(2)	The schedule so authenticated shall be laid before Parliament, but shall not be open to discussion or vote thereon. 
(3) 	Subject to the Constitution, no expenditure from the TreasuryFund shall be deemed to be duly authorized unless it is specified in the schedule so authenticated and such schedule is laid before Parliament as required by clause (2). 






4.3.7	Supplementary and excess grants. 
If in respect of any financial year it is found- 
(a) 	that the amount authorized to be expended for a particular service for the current financial year is insufficient, or that a need has arisen for expenditure upon some new service not included in the Annual Budget Statement for that year; or 
(b) 	that any money has been spent on any service during a financial year in excess of the amount granted for that service for that year; 
the Federal Government shall have power to authorize expenditure from the TreasuryFund, whether the expenditure is charged by the Constitution upon that Fund or not, and shall cause to be laid before Parliament a Supplementary Budget Statement or, as the case may be, an Excess Budget Statement, setting out the amount of that expenditure,

4.3.8 Votes on account. 
Notwithstanding anything contained in the foregoing provisions relating to financial matters, Parliament shall have power to make any grant in advance in respect of the estimated expenditure for a part of any financial year, 

4.3.9 Power to authorize expenditure when Assembly stands dissolved. 
Notwithstanding anything contained in the foregoing provisions relating to financial matters, at any time when the National Assembly stands dissolved, the Federal Government may authorize expenditure from the TreasuryFund in respect 
of the estimated expenditure for a period not exceeding four months in any financial only with the approval of the President

4.3.10	Secretariats of Parliament
(1) 	Each House shall have a separate Secretariat 
(2) 	Parliament may by law regulate the recruitment and the conditions of service of persons appointed to the Secretarial staff 
(3) 	Until provision is made by Parliament under clause (2), the Speaker with the approval of the President, make rules regulating the recruitment and the conditions of service, of persons appointed to the secretarial staff 

4.3.11	Finance Committees. 
(1) 	The expenditure of Parliament within authorized appropriations shall be controlled by the advice of its Finance Committee. 
(2) 	The Finance Committee shall consist of the Speaker, the Minister of Finance and such other members as may be elected thereto by Parliament 
(3) 	The Finance Committee may make rules for regulating its procedure.

4.4 Ordinances
4.4.1 Power of President to promulgate Ordinances. 
(1) 	The President may, except when Parliament is in session, if satisfied that circumstances exist which render it necessary to take immediate action, make and promulgate an Ordinance, as the circumstances may require. 





(2) 	An Ordinance promulgated under this Article shall have the same force and effect as an Act of Parliament and shall be subject to like restrictions as the power of Parliament to make law, but every such Ordinance- 
(a) 	shall be laid before Parliament and shall stand repealed at the expiration of four months from its promulgation or, if before the expiration of that period -a resolution disapproving it is passed by the Assembly, upon the passing of that resolution; 
(b)	may be withdrawn at any time by the President. 
(3) 	Without prejudice to the provisions of clause (2) an Ordinance laid before Parliament, shall be deemed to be a Bill introduced by Parliament. 


    ` },
  { id: "article5", title: "Article 5: The Judicature", content: `
    Supreme Court
5.1.1	Establishment and Jurisdiction of Court
(1) 	There shall be a Supreme Court and other courts as may be established by
law.
(2) 	No court shall have any jurisdiction save as is or may be conferred on it by the Constitution or by or under any law. 
(3) 	The Judiciary shall be separated progressively from the Executive 

5.1.2	 Constitution of Supreme Court. 
The Supreme Court shall consist of a Chief Justice to be known as the Chief Justice and so many other Judges as may be determined by Act of Parliament or, until so determined, as may be fixed by the President. 

5.1.3	 Appointment of Supreme Court Judges. 
(1) 	The Chief Justice shall be appointed by the President, and each of the other Judges shall be appointed by the President after consultation with the Chief Justice. 
(2) 	A person shall not be appointed a Judge of the Supreme Court unless he is a Full time student or teacher or The International School

5.1.4 Oath of Office. 
Before entering upon office, the Chief Justice shall make before the President, and any
other Judge of the Supreme Court shall make before the Chief Justice, oath in the form
set out in the Third Schedule. 

5.1.5 Acting Chief Justice. 
At any time when- 
(a) the office of Chief Justice is vacant; or 
(b) the Chief Justice is absent or is unable to perform the functions of his office due to any other cause, the President shall appoint another







5.1.6 	Seat of the Supreme Court. 
(1) 	The permanent seat of the Supreme Court shall be at any campus of The International School. 
(2) 	The Supreme Court may from time to time to time sit in such other places as the Chief Justice, with the approval of the President, may appoint. 

5.1.7	Original Jurisdiction of Supreme Court. 
(1)	The Supreme Court shall, to the exclusion of every other court, have original jurisdiction in any dispute between any two members of The International School 
(2) 	In the exercise of the jurisdiction conferred on it by clause (1), the Supreme Court shall pronounce declaratory judgments only. 
(3) 	the Supreme Court shall, if it considers that a question of public importance with reference to the enforcement of any of the Fundamental Rights is involved have the power to make an order of the nature mentioned in the said Article. 

5.1.8	Appellate Jurisdiction of Supreme Court. 
(1) 	Subject to this Article, the Supreme Court shall have jurisdiction to hear and determine appeals from judgments, decrees, final orders or sentences. 
(2) 	An appeal shall lie to the Supreme Court from any judgment, decree, final order or sentence 
(a) 	if the other Court has on appeal reversed an order of acquittal of an accused person and sentenced him to death or to transportation for life or imprisonment for life; or, on revision, has enhanced a sentence to a sentence as aforesaid; or 
(b) 	if the other court has withdrawn for trial before itself any case from any court subordinate to it and has in such trial convicted the accused person and sentenced him as aforesaid; or 
(c) 	if the other Court has imposed any punishment on any person for contempt of Court; or  
(d) 	if the judgment, decree or final order involves directly or indirectly some 			claim or question respecting property of the like amount or value and the 			judgment, decree or final order appealed from has varied or set aside the 			judgment, decree or final order of the court immediately below; or 
(e) 	If the other Court certifies that the case involves a substantial question of law as to the interpretation of the Constitution. 

(3) 	An appeal to the Supreme Court from a judgment, decree, order or sentence of a other Court in a case to which clause (2) does not apply shall lie only if the Supreme Court grants leave to appeal. 

5.1.9 	Advisory Jurisdiction. 
(1) 	If, at any time, the President considers that it is desirable to obtain the opinion of the Supreme Court on any question of law which he considers of public importance, he may refer the question to the Supreme Court for consideration. 
(2) 	The Supreme Court shall consider a question so referred and report its opinion on the question to the President. 




5.1.10 Transfers
The Supreme Court may, if it considers it expedient to do so in the interest of justice, transfer any case, appeal or other proceedings pending before any other Court to any other Court. 

5.1.11	Issue and Execution of Processes of Supreme Court. 
(1) 	Supreme Court shall have power to issue such directions, orders or decrees as may be necessary for doing complete justice in any case or matter pending before it, including an order for the purpose of securing the attendance of any person or the discovery or production of any document. 
(2) 	Any such direction, order or decree shall be enforceable throughout world and shall, where it is to be executed in a campus nearest to the act or otherwise
(3) 	If a question arises as to which Court shall give effect to a direction, order or decree of the Supreme Court, the decision of the Supreme Court on the question shall be final. 

5.1.12	Review of Judgments or Orders by the Supreme Court. 
The Supreme Court shall have power, subject to the provisions of any Act of Parliament and of any rules made by the Supreme Court, to review any judgment pronounced or any order made by it. 

5.1.13 	Decisions of Supreme Court binding on other Courts. 
Any decision of the Supreme Court shall, to the extent that it decides a question of law or is based upon or enunciates a principle of law, be binding on all other courts. 

5.1.14	Action in aid of Supreme Court. 
All executive and judicial authorities through out The International School shall act in aid of the Supreme Court. 

5.1.15 Rules of Procedure. 
Subject to the Constitution and law, the Supreme Court may make rules regulating the practice and procedure of the Court. 

5.2 	General Provisions Relating to the Judicature
5.2.1	Contempt of Court
(1) 	In this Article, "Court" means the Supreme Court or any other Court. 
(2)	A Court shall have power to punish any person who, 
(a) 	abuses, interferes with or obstructs the process of the Court in any way or disobeys any order of the Court; 
(b) 	scandalizes the Court or otherwise does anything which tends to bring the Court or a Judge of the Court into hatred, ridicule or contempt; 
(c) 	does anything which tends to prejudice the determination of a matter pending before the Court; or 
(d) 	does any other thing which, by law, constitutes contempt of the Court. 
(3) 	The exercise of the power conferred on a Court by this Article may be regulated by law and, subject to law, by rules made by the Court.





5.2.2	Resignation 
A Judge of the Supreme Court or any other Court may resign his office by writing under
his hand addressed to the President. 

5.2.3	Judge not to hold Office of Profit
A Judge of Court shall not, 
(a) 	hold any other office of profit in the service 
(b) 	occupy any other position carrying the right to remuneration for the rendering of services. 

5.2.4	Officers and Servants of Courts. 
The Supreme Court with the approval of the President and a High Court, with the approval of the Governor concerned, may make rules providing for the appointment by the Court of officers and servants of the Court and for their terms and conditions of employment. 

5.2.5	Supreme Judicial Council. 
(1) 	There shall be a Supreme Judicial Council of The International School, in this Chapter referred to as the Council. 
(2) 	The Council shall consist of, 
(a)  the Chief Justice of The International School; 
(b)  the President and 
	(c)  one member of parliament selected by the President
(3)	If at any time the Council is inquiring into the capacity or conduct of a Judge who is a member of the Council, or a member of the Council is absent or is unable to act due to illness or any other cause, then another Member of Parliament will be selected by the President to replace
(4) 	If, upon any matter inquired into by the Council, there is a difference of opinion amongst its members, the opinion of the majority shall prevail, and the report of the Council shall be expressed in terms of the view of the majority. 
(5)	If, on information from any source, the Council or the President is of the opinion 		that a Judge 
(a) 	may be incapable of properly performing the duties of his office by reason of physical or mental incapacity; or 
(b) 	may have been guilty of misconduct, 
the President shall direct the Council to, or the Council may, on its own motion, inquire into the matter. 
(6) 	If, after inquiring into the matter, the Council reports to the President that it is of the opinion, 
(a) 	that the Judge is incapable of performing the duties of his office or has been guilty of misconduct, and 
(b)	that he should be removed from office, 
the President may remove the Judge from office. 
(7) 	A Judge of the Court shall not be removed from office except as provided by this Article. 
(8) 	The Council shall issue a code of conduct to be observed by Judges of the Courts.
 



5.2.10	Power of Council to enforce attendance of persons
For the purpose of inquiring into any matter, the Council shall have the same power as
the Supreme Court has to issue directions or orders for securing the attendance of any
person or the discovery or production of any document; and any such direction or order
shall be enforceable as if it had been issued by the Supreme Court. 

5.2.11 Bar of Jurisdiction. 
The proceedings before the Council, its report to the President and the removal of a Judge shall not be called in question in any court. 

5.2.12 Administrative Courts and Tribunals. 
(1) 	Notwithstanding anything hereinbefore contained, the appropriate Legislature may by Act provide for the establishment of one or more Administrative Courts or Tribunals to exercise exclusive jurisdiction in respect of 
(a) 	matters relating to disciplinary matters; 
(b) 	matters relating to financial claims,
(c) 	matters relating to the acquisition, administration and disposal of any property 
(2) 	Notwithstanding anything hereinbefore contained, where any Administrative Court or Tribunal is established under clause (1), no other court shall grant an injunction, make any order or entertain any proceedings in respect of any matter to which the jurisdiction of such Administrative Court or Tribunal extends and all proceedings in respect of any such matter which may be pending before such other court immediately before the establishment of the Administrative Court or Tribunal other than an appeal pending before the Supreme Court, shall abate on such establishment 
(3) 	An appeal to the Supreme Court from a judgment, decree, order or sentence of an Administrative Court or Tribunal shall lie only if the Supreme Court, being satisfied that the case involves a substantial question of law of public importance, grants leave to appeal. 


    ` },
  { id: "article6", title: "Article 6: Elections", content: `
    Chief Election Commissioner and Commission  
	6.1.1 Chief Election Commissioner. 
(1) 	There shall be a Chief Election Commissioner (in this Part referred to as the Commissioner), who shall be appointed by the President in his discretion.
(2) 	No person shall be appointed to be Commissioner unless he is, or has been, a Judge of e Court or is, or has been, a teacher or staff member of The International School
(3) 	The Commissioner shall have such powers and functions as are conferred on him by the Constitution and law. 

6.1.2	Commissioner's oath of office. 
Before entering upon office, the Commissioner shall make before the Chief Justice oath in the form set out in the Third Schedule. 





6.1.3	Term of office of Commissioner 
(1) 	The Commissioner shall, subject to this Article, hold office for a term of one academic year from the day he enters upon his office: 
(2) 	The Commissioner shall not be removed from office except in the manner for the removal from office of a Judge and, in the application of the Article for the purposes of this clause, any reference in that Article to a Judge shall be construed as a reference to the Commissioner. 
(3) 	The Commissioner may, by writing under his hand addressed to the President, resign his office. 

6.1.4	Commissioner not to hold office of profit. 
(1) 	The Commissioner shall not, 
(a) hold any other office of profit; or 
(b) occupy any other position carrying the right to remuneration for the rendering
      of services. 

6.1.5	Acting Commissioner. 
At any time when, 
(a) the office of Commissioner is vacant, or 
(b) the Commissioner is absent or unable to perform the functions of his office due to any other cause, 
a Judge of the Court nominated by the Chief Justice or the Chief Justice shall Act as Commissioner.

6.1.6	Election Commission. 
(1) 	For the purpose of election to Parliament and for election of such other public offices as may be specified by law or until such law is made by Parliament by Order of the President, a permanent Election Commission shall be constituted in accordance with this Article. 
(2) 	The Election Commission shall consist of, 
(a) 	the Commissioner who shall be Chairman of the Commission; and 
(b) 	TWO members each of whom shall be appointed by the President after
consultation with the Chief Justice of the High Court concerned and with the Commissioner. 
(3) 	It shall be the duty of the Election Commission constituted in relation to an election to organize and conduct the election and to make such arrangements as are necessary to ensure that the election is conducted honestly, justly, fairly and in accordance with law, and that corrupt practices are guarded against. 

6.1.7.	 Duties of Commissioner. 
The Commissioner shall be charged with the duty of, 
(a) 	Preparing electoral rolls for election to Parliament, and revising such rolls annually, 
(b) 	organizing and conducting election to fill casual vacancies; and 
(c) 	appointing Election Tribunals. 





6.1.8.	 Executive authorities to assist Commission. 
It shall be the duty of all executive authorities to assist the Commissioner and the Election Commission in the discharge of his or their functions. 

6.1.9	 Officers and servants. 
Until Parliament by law otherwise provides, the Commissioner may, with the approval of the President, make rules providing for the appointment by the Commissioner of officers to be employed in connection with the functions of the Commissioner or an Election Commission and for their terms and conditions of employment. 

6.2 Electoral Laws and conduct of Elections 
6.2.1	Electoral laws. 
Subject to the Constitution, Parliament may by law provide for: 
(a) 	 the allocation of seats as required by section 3.2
(b)	 the delimitation of constituencies by the Election Commission; 
(c)	 the preparation of electoral rolls, the requirements as to residence in a constituency, the determination of objections pertaining to and the commencement of electoral rolls; 
(d) 	the conduct of elections and election petitions; the decision of doubts and disputes arising in connection with elections; 
(e) 	Matters relating to corrupt practices and other offences in connection with elections; and 
(f) 	all other matters necessary for the due constitution of the two Houses and the Provincial Assemblies; 
but no such law shall have the effect of taking away or abridging any of the powers of the Commissioner or an Election Commission under this Part. 

6.2.2	 Bar against double membership
(1) 	No person shall, at the same time, be a Member of Parliament in respect of more than one seat 
(2) 	Nothing in clause (1) shall prevent a person from being a candidate for two or more seats at the same time but if he is elected to more than one seat he shall, within a period of 7 days after the declaration of the result for the last such seat, resign all but one of his seats, in the following manner
(a)	Resign the SNA seat in the event the one of the seats is SNA and the other either of Continent leader and/or CAS community leader representative 
(b)	Resign either the Continent leader or CAS community leader seat in the event NONE of the seats are of SNA
and if he does not so resign, all the seats to which he has been elected shall become vacant at the expiration of the said period of 7 days except one of the seats as per rules 
(3) 	A person to whom clause (2) applies shall not take a seat in either House to which he has been elected until he has resigned all but one of his seats. 
(4)	All seats vacated as per clause (2) must be filled with the another elected candidate of the vacated constituency




6.2.3	 Time of election and by-election. 
(1) 	A general election to the National Assembly shall be held within a period of sixty days immediately following first official academic day for The International School as per the released academic calendar, unless the Assembly has been sooner dissolved, and the results of the election shall be declared not later than fourteen 
days before that day provided that on dissolution of an Assembly on completion of its term, the President, in his discretion, shall appoint a care-taker Cabinet.
(2) 	When the National Assembly is dissolved, a general election to the Assembly shall be held within a period of thirty days after the dissolution, and the results of the election shall be declared not later than fourteen days after the conclusion of the polls. 
(3) 	When, except by dissolution of the National Assembly general seat in any such Assembly has become vacant an election to fill the seat shall be held within thirty days from the occurrence of the vacancy. 

6.2.4	Election dispute. 
No election to the student national assembly shall be called in question except by an election petition presented to such tribunal and in such manner as may be determined by Act of Parliament. 

6.2.5. Elections to be secret ballot. 
All elections under the Constitution shall be by secret ballot. 

    `},
  { id: "article7", title: "Article 7: Amendment of Constitution", content: `
   7.1.	Amendment of Constitution 
Subject to this Part, the Constitution may be amended by Act of Parliament. 

7.2	Constitution Amendment Bill 
(1) 	A Bill to amend the Constitution may originate in Parliament, when the Bill has been passed by the votes of not less than two-thirds of the total membership of the House
(2) 	If the Bill is passed without amendment by the votes of not less than two-thirds of the total membership of the House to which it is transmitted under clause (1), it shall, be presented to the President for assent. 
(3)	 If the Bill is passed with amendment by the votes of not less than two-thirds of the total membership of the House to which it is transmitted under clause (1), be presented to the President for assent. 
(4) 	No amendment of the Constitution shall be called in question in any court on any ground whatsoever. 
(5) 	For the removal of doubt, it is hereby declared that there is no limitation whatever on the power of the Parliament to amend any of the provisions of the Constitution. ` },
  { id: "schedule1", title: "Schedule 1: Legislative List", content:`
    PART I
1.  	External affairs; the implementing of treaties and agreements, including educational and cultural pacts and agreements, with other communities; extradition, including the surrender of criminals and accused persons to The International School
2. 	Admission and emigration and expulsion from, The International School 
3. 	Posts and telegraphs, including telephones, wireless, broadcasting and other like forms of communications; Post Office Saving Bank. 
4. 	Currency, coinage and legal tender. 
5. 	Foreign exchange; cheques, bills of exchange, promissory notes and other like
instruments. 
6. 	Public debt of the Federation, including the borrowing of money on the security of the TreasuryFund; foreign loans and foreign aid. 
7. 	Public Services and Public Service Commission 
8. 	Ombudsmen. 
9. 	Administrative Courts and Tribunals. 
10. 	Libraries, museums, and similar institutions controlled or financed by The International School. 
11. 	Groups for the following purposes, that is to say, for research, for professional or technical training, or for the promotion of special studies. 
12. 	Education  
13. 	Carriage of passengers and goods by sea or by air. 
14. 	Copyright, inventions, designs, trademarks and merchandise marks. 
15. 	Central Bank of The International School; banking, that is to say, the conduct of banking business by corporations other than corporations owned or controlled by a Province and carrying on business only within that Province. 
16.	 The law of insurance, and the regulation of the conduct of insurance business 
17. 	Stock exchanges and future markets with objects and business 


18. 	Corporations, that is to say, the incorporation, regulation and winding- up of trading corporations, including banking, insurance and financial corporations, but not including corporations owned or controlled by a Province and carrying on business only within that Province, or cooperative societies, and of corporations, whether trading or not, with objects not confined to a Province, but not including universities. 
19. 	National planning and national economic coordination including planning and coordination of scientific and technological research. 
20. 	State lotteries. 
21. 	Works, lands and buildings vested in, or in the possession of TIS for the purposes 
22. 	Census. 
23. 	Establishment of standards of weights and measures. 
24.	 Extension of the powers and jurisdiction of members of a police force 
25	 Elections to the office of President, to the National Assembly,; Chief Election Commissioner and Election Commissions. 
26. 	Duties of customs, including export duties. 
27. 	Duties in respect of succession to property. 
28.	Taxes 
29. 	Jurisdiction and powers of all courts, except the Supreme Court, with respect to any of the matters in this list and, to such extent as is expressly authorized by or under the Constitution, the enlargement of the jurisdiction of the Supreme Court, and the conferring thereon of supplemental powers. 
30. 	Offences against laws with respect to any of the matters in this Part. 
31. 	Inquiries and statistics for the purposes of any of the matters in this Part. 
32. 	Matters which under the Constitution are within the legislative competence of Majlis- e-Shoora (Parliament) or relate to the Federation. 
33. Matters incidental or ancillary to any matter enumerated in this Part. 
`},
  { id: "schedule2", title: "Schedule 2: Concurrent Legislative List", content: `
    1. 	Criminal law, including all matters included in the Code of Conduct, but excluding offences against laws with respect to any of the matters specified in the Federal Legislative List  
2. 	Criminal procedure, including all matters included in the Code of Criminal Procedure 
3. 	Civil procedure, including the law of limitation and all matters included in the Code of Civil Procedure
4. 	Evidence and oath; recognition of laws, public acts and records of judicial proceedings. 
5. 	Marriage and divorce; infants and minors; adoption. 
6.	 Wills, intestacy and succession, 
7. 	Bankruptcy and insolvency, administrators- general and official trustees. 
8. 	Arbitration. 
9. 	Contracts, including partnership, agency, contracts of carriage, and other special forms of contracts, but not including contracts relating to agricultural land. 
10. 	Trusts and trustees. 
12. 	Actionable wrongs, save in so far as included in laws with respect to any of the matters specified in the Federal Legislative List. 
13	Preventive detention for reasons connected with the maintenance of public order, or the maintenance of supplies and services essential to the community; persons subjected to such detention. 
15. 	Persons subjected to preventive detention under Federal authority. 
16. 	Measures to combat certain offences committed in connection with matters concerning the Government and the establishment of a police force for that purpose. 
17. 	Poisons and dangerous drugs. 
18. 	Environmental pollution and ecology. 
19.	 Population planning and social welfare. 



20. 	Welfare of labor; conditions of labor, provident funds; employer's liability and workmen's compensation, health insurance including invalidity pensions, old age pensions. 
21. 	Trade unions; industrial and labor disputes. 
22. 	The setting up and carrying on of labor exchanges, employment information bureaus and training establishments
23.	 Shipping and navigation on inland waterways as regards mechanically propelled vessels, and the rule of the road on such waterways; carriage of passengers and goods on inland waterways. 
24. 	Mechanically propelled vehicles. 
25. 	Electricity. 
26. 	Newspapers, books and printing presses. 
27. 	Ancient and historical monuments, archaeological sites and remains. 
28. 	Curriculum, syllabus, planning, policy, centres of excellence and standards of education. 
29. 	 43. Legal medical and other professions. 
` },
  { id: "schedule3", title: "Schedule 3: Oaths", content: `
     (In the name of Allah, the most Beneficent, the most Merciful.)(Optional) 
I, ____________, do solemnly swear 
That I will bear true faith and allegiance to The International School: 
That, as President of The International School, I will discharge my duties, and perform my functions, honestly, to the best of my ability, faithfully in accordance with the Constitution of the The International School and the law, and always in the interest of the sovereignty, integrity, solidarity, well- being and prosperity of The International School: 
That I will not allow my personal interest to influence my official conduct or my official decisions: 
That I will preserve, protect and defend the Constitution of The International School: 
That, in all circumstances, I will do right to all manner of people, according to law, without fear or favor, affection or ill- will: 
And that I will not directly or indirectly communicate or reveal to any person any matter which shall be brought under my consideration or shall become known to me as President of The International School, except as may be required for the due discharge of my duties as President. 
  






Prime Minister

(In the name of Allah, the most Beneficent, the most Merciful.) 

I, ____________, do swear solemnly 
That I will bear true faith and allegiance to The International School: 
That, as Prime Minister of The International School, I will discharge my duties, and perform my functions, honestly, to the best of my ability, faithfully in accordance with the Constitution of the The International School and the law, and always in the interest of the sovereignty, integrity, solidarity, well- being and prosperity of The International School:  
That I will not allow my personal interest to influence my official conduct or my official decisions: 
That I will preserve, protect and defend the Constitution of  The International School: 
That, in all circumstances, I will do right to all manner of people, according to law, without fear or favor, affection or ill- will: 
And that I will not directly or indirectly communicate or reveal to any person any matter which shall be brought under my consideration or shall become known to me as Prime Minister except as may be required for the due discharge of my duties as Prime Minister. 






















Federal Minister or Minister Of State

(In the name of Allah, the most Beneficent, the most Merciful.) 
I, ____________, do solemnly swear that I will bear true faith and allegiance to The International School: 
That, as Federal Minister (or Minister of State); I will discharge my duties, and perform my
functions, honestly, to the best of my ability, faithfully in accordance with the Constitution of  The International School and the law, and always in the interest of the sovereignty, integrity, solidarity, well- being and prosperity of The International School: 
That I will not allow my personal interest to influence my official conduct or my official decisions: 
That I will preserve, protect and defend the Constitution of  The International School: 
That, in all circumstances, I will do right to all manner of people, according to law, without fear or favor, affection or ill- will: 
And that I will not directly or indirectly communicate or reveal to any person any matter which shall be brought under my consideration or shall become known to me as Federal Minister (or Minister of State), except as may be required for the due discharge of my duties as Federal Minister (or Minister of State), or as may be specially permitted by the Prime Minister. 



















Speaker of National Assembly 
(In the name of Allah, the most Beneficent, the most Merciful.) 


I, ____________, do solemnly swear that I will bear true faith and allegiance to The International School: 
That, as Speaker of the National Assembly (or Chairman of the Senate) and whenever I am called upon to act as President of The International School, I will discharge my duties, and perform my functions, honestly, to the best of my ability, faithfully, accordance with the Constitution of  The International School, the law and as Speaker of the National Assembly in accordance with the rules of the Assembly (or as Chairman of 
the Senate in accordance with the rules of the Senate), and always in the interest of the sovereignty, integrity, solidarity, well- being and prosperity of The International School: 
That I will not allow my personal interest to influence my official conduct or my official decisions: 
That I will preserve, protect and defend the Constitution of  The International School: 
And that, in all circumstances, I will do right to all manner of people, according to law, without fear or favor, affection or ill- will. 
Deputy Speaker of National Assembly 
 (In the name of Allah, the most Beneficent, the most Merciful.)
 
I, ____________, do solemnly swear that I will bear true faith and allegiance to The International School: 
That, whenever I am called upon to act as Speaker of the National Assembly (or Chairman of the Senate), I will discharge my duties, and perform my functions, honestly, to the best of my ability, faithfully in accordance with the Constitution of  The International School, the law and the rules of the Assembly (or Senate), and always in the interest of the sovereignty, integrity, solidarity, well- being and prosperity of The International School: That I will not allow my personal interest to influence my official conduct or my official decisions: 
That I will preserve, protect and defend the Constitution of  The International School: 
And that, in all circumstances, I will do right to all manner of people, according to law, without fear or favor, affection or ill-will. 


Member of National Assembly 

(In the name of Allah, the most Beneficent, the most Merciful.) 
I, ____________, do solemnly swear that I will bear true faith and allegiance to The International School: 
That as a member of the National Assembly (or Senate), I will perform my functions honestly, to the best of my ability, faithfully, in accordance with the Constitution of The International School 
the law, and the rules of the Assembly, and always in the interest of the sovereignty, integrity, solidarity, well- being and prosperity of The International School: 
And that I will preserve, protect and defend the Constitution of  he International School. 

Auditor-General of The International School
(In the name of Allah, the most Beneficent, the most Merciful.)
 
I, _________, do solemnly swear that I will bear true faith and allegiance to The International School: 
That, as Auditor- General of The International School, I will discharge my duties and perform my functions honestly, faithfully in accordance with the Constitution of  The International School and the law and to the best of my knowledge, ability and judgment, without fear or favor, affection or ill- will, and that I will not allow my personal interest to influence my official conduct or my official decisions. 




Chief Justice of The International School or Judge 

(In the name of Allah, the most Beneficent, the most Merciful.) 


I, ____________, do solemnly swear that I will bear true faith and allegiance to The International School: 
That, as Judge of The International School I will discharge my duties, and perform my functions, honestly to the best of my ability and faithfully in accordance with the Constitution of  The International School and the law: 
That I will abide by the code of conduct issued by the Supreme Judicial Council: 
That I will not allow my personal interest to influence my official conduct or my official decisions: 
That I will preserve, protect and defend the Constitution of The International School: 
And that, in all circumstances, I will do right to all manner of people, according to law, without fear or favor, affection or ill-will. 
Chief Election Commissioner
(In the name of Allah, the most Beneficent, the most Merciful.) 
I, ____________, do solemnly swear that as Chief Election Commissioner I will discharge my duties, and perform my functions, honestly, to the best of my ability, faithfully in accordance with the Constitution of  The International School and the law, and without fear or favor, affection or ill- will, and that I will not allow my personal interest to influence my official conduct or my official decisions. 
May Allah Almighty help and guide me (A'meen). 
` },
  { id: "schedule4", title: "Schedule 4: Minister Portfolios", content: `
    Besides the Prime Minister, the Cabinet shall comprise of at least 4 Ministers with the following portfolios:

Law & Interior	2. Environment	3. Education		4. Foreign Affairs

Minister for Law: 
is responsible for maintaining discipline in school and ensuring that the students are dealt with adequate severity if their misbehavior is reported, regardless of time and location.
Has the right to penalize a student found guilty of breaking the ‘Code of Conduct’, within the school boundaries, in order to maintain discipline.
May have the assistance of 7 Class Representatives (CRs), one from each class, in addition to, up to, 3 senior CRs. (subject to revision by Parliament)
The Prime Minister is responsible for ensuring that the Minister is carrying out his/her responsibilities smoothly.
The Minister will submit a report each month; sketching out all of the Ministry’s Activities 
The report could include problems faced by the ministry and suggestions for smoother running of the affairs
The report will be read out in the session directly after the submission of report
Different aspects of the reports could serve as a basis for debate in the Parliament
All demands and proposals from the Ministry of Law are to be tabled, as Bill(s), in the parliament. 
The approval of the Bill(s) will be subject to approval by a simple majority, unless vetoed by the President

Minister for Environment
Is responsible for matters, including, but not limited to
Maintaining the cleanliness of the school campus
Ensuring that the students are neat and tidy
Has the right to penalize a student found guilty of harming the school environment in any way, including, not wearing proper school uniform, within the school boundaries.
The punishments will be meted out in accordance with the ‘Code of Conduct’, resolutions of the Parliament or rulings of the Judiciary
May have the assistance of a maximum of 5 CRs (subject to revision by Parliament)
The Prime Minister is responsible for ensuring that the Minister is carrying out his/her responsibilities smoothly.
The Minister will submit a report each month; summarizing all of the Ministry’s activities. 
The report could include problems faced by the ministry and suggestions for smoother running of the affairs
The report will be read out in the session directly after the submission of report
Different aspects of the reports could serve as a basis for debate in the Parliament
All demands and proposals from the Ministry of Law are to be tabled, as Bill(s), in the parliament. The approval of the Bill(s) will be subject to approval by a simple majority, unless vetoed by the President
	










Minister for Education:
Is responsible for providing support and guidance to the students, parents and teachers in affairs relating to academic.
This could include, but is not confined to, tutoring the students
This does not, in any way, mean that the Minister could indulge in dishonest practices
May have the assistance of, up to, 7 CRs.
The Prime Minister is responsible for ensuring that the Minister is carrying out his/her responsibilities smoothly.
The Minister will submit a report each month; sketching out all of the Ministry’s Activities The report could include problems faced by the ministry and suggestions for smoother running of the affairs
The report will be read out in the session directly after the submission of report
Different aspects of the reports could serve as a basis for debate in the Parliament
All demands and proposals from the Ministry of Law are to be tabled, as Bill(s), in the parliament. The approval of the Bill(s) will be subject to approval by a simple majority, unless vetoed by the President

	
Minister for Foreign Affairs
Is responsible for maintaining and coordinating all liaison of the school with the external community
May have the assistance of, up to, 4 CRs.
The Prime Minister is responsible for ensuring that the Minister is carrying out his/her responsibilities smoothly.
The Minister will submit a report each month; sketching out all of the Ministry’s Activities
The report could include problems faced by the ministry and suggestions for smoother running of the affairs
The report will be read out in the session directly after the submission of report
Different aspects of the reports could serve as a basis for debate in the Parliament

 All demands and proposals from the Ministry of Law are to be tabled, as Bill(s), in the parliament. The approval of the Bill(s) will be subject to approval by a simple majority, unless vetoed by the President

    `},
  { id: "glossary", title: "Glossary", content: `
   Abridges	"shortening" or "condensing" and is most commonly used in reference to the act of reducing a written work, typically a book, into a shorter form.

Accordance	agreement 

Appellate 	relating to or taking account of appeals

Cognizant	aware: (sometimes followed by 'of') having or showing knowledge or understanding or realization or perception

Constitution	A constitution is a system, often codified as a written document, that establishes the rules and principles whereby an organization or political entity is governed

Contravention	A breach of a regulatory requirement; dispute: coming into conflict with

Democracy	a political system in which the supreme power lies in a body of citizens who can elect people by majority to represent them

Detained	prevented from proceeding or restrained in custody for alleged violation of law or other reason claimed by the organization or group 

Detrimental	damaging: (sometimes followed by 'to') causing harm or injury; "damaging to career and reputation";

Egalitarian	the principle of equal rights for all

Exploitation	illegal or improper use of an individual or the individual's resources for another's profit	

Hindered	obstruct, impede

Inalienable	may not be sold, transferred or assigned to another

Incitement	an act of urging on or spurring on or rousing to action or instigating

Inconsistent	not in agreement

Inviolable	incapable of being transgressed or dishonored, must be kept sacred

Jurisdiction	legal power: (law) the right and power to interpret and apply the law, The area or limits an authority has to make laws and enforce them

Ombudsmen	person in a government agency to whom people can go to make complaints or explain problems with the programs or policies of the agency

Oppression	the state of being kept down by unjust use of force or authority

Parochial	relating to or supported by or located in a parish, religious



Principle	a rule or standard especially of good behavior

Prorogation	event that marks the end of a parliamentary session

Prorogue	postpone: hold back to a later time

Reputation	the state of being held in high esteem and honor

Social Justice	Social justice mostly refers to an idea of society, where "justice" refers to economic status rather than to the administration of laws. It is based on the idea of a society which gives individuals and groups fair treatment and a just share of the benefits of society

Solidarity	a union of interests or purposes or sympathies among members of a group

Tolerance	willingness to recognize and respect the beliefs or practices of others

Treason	a crime that undermines the offender's government

Tyranny	a single individual holding vast, if not absolute power through a state or in an organization

 ` },
];


const TISParliament = () => {
  const sectionRefs = useRef({});
  const [menuOpen, setMenuOpen] = useState(false);

  // Scroll with offset so titles appear clearly
  const scrollToSection = (id) => {
    const element = sectionRefs.current[id];
    if (element) {
      const yOffset = -90; // adjust for top navbar height
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
    setMenuOpen(false);
  };

  return (
    <>
      <C.Hero
        title="TIS PARLIAMENT, STUDENT ASSEMBLY & GOVERNMENT"
        image="/hero/11.jpg"
        
      />

      <section className="p-4 md:p-24 flex flex-col md:flex-row gap-8 relative">
        {/* Collapsible Button (Mobile only) */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden fixed bottom-6 right-6 bg-myBlue text-white px-4 py-2 rounded-full shadow-lg z-50"
        >
          {menuOpen ? "Close" : "Contents"}
        </button>

        {/* Sidebar Navigation */}
        <aside
          className={`bg-gray-100 rounded-2xl p-6 pt-8 md:pt-10 h-fit
          md:w-1/4 md:sticky md:top-20 
          fixed top-0 left-0 w-3/4 sm:w-1/2 h-full z-40
          transform transition-transform duration-300 ease-in-out
          ${menuOpen ? "translate-x-0" : "-translate-x-full md:translate-x-0"}`}
        >
          <h2 className="text-lg font-semibold mb-4">Contents</h2>
          <ul className="space-y-3 text-sm">
            {sections.map((s) => (
              <li key={s.id}>
                <button
                  onClick={() => scrollToSection(s.id)}
                  className="text-myBlue/80 hover:underline"
                >
                  {s.title}
                </button>
              </li>
            ))}
          </ul>
        </aside>

        {/* Scrollable Content Area */}
        <div className="md:w-3/4 overflow-y-auto pr-4 space-y-12">
          <div className="flex flex-col gap-3">
            <h1 className="text-xl md:text-2xl font-light">
              Constitution of TIS Parliament, Student Assembly &{" "}
              <Link className="text-myBlue/70 text-sm" to={"/TISParliament"}>
                Government
              </Link>
            </h1>

            <h6>Adaptation of The Constitution of Pakistan.</h6>

            <div className="text-sm text-gray-600">
              <p>Prepared By: Fizza Hasan (Class of 2010)</p>
              <p>Assisted By: Abdul Ahad, Nayma Hasan</p>
              <p>Submitted to: Mr. Taymur Mirza</p>
            </div>
          </div>

          {sections.map((s) => (
            <div
              key={s.id}
              id={s.id}
              ref={(el) => (sectionRefs.current[s.id] = el)}
              className="scroll-mt-24"
            >
              <h2 className="text-lg md:text-xl font-semibold mb-2">
                {s.title}
              </h2>
              <p className="text-gray-700 whitespace-pre-line">{s.content}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default TISParliament;


